'use client';

import { useEffect } from 'react';

const STN_SHADOW_STYLES = [
  '.playlistContainer { visibility: hidden !important; pointer-events: none !important; }',
  '.voltax-mp-title-bar { display: none !important; }',
].join(' ');

/**
 * Overrides the styles inside the voltax-player's shadow DOM
 * for the `.stn-video-player` container matching the given target string.
 * Uses a MutationObserver to handle the player loading asynchronously.
 */
export function useOverrideStnPlayerStyles(target: string) {
  useEffect(() => {
    const container = document.querySelector(`.stn-video-player[class*="${target}"]`);
    if (!container) {
      return;
    }

    const injectStyles = () => {
      const shadowRoot = container.querySelector('voltax-player')?.shadowRoot;
      if (!shadowRoot || shadowRoot.querySelector('#stn-player-overrides')) {
        return;
      }

      const style = document.createElement('style');
      style.id = 'stn-player-overrides';
      style.textContent = STN_SHADOW_STYLES;
      shadowRoot.appendChild(style);
    };

    const observer = new MutationObserver(injectStyles);
    observer.observe(container, { childList: true, subtree: true });
    injectStyles();

    return () => observer.disconnect();
  }, [target]);
}
